export default __webpack_public_path__ + "static/media/Distibuted servers.d239b0b6.png";